document.documentElement.classList.remove('no-js');
document.addEventListener('click', function(e){
  const toggle=e.target.closest('[data-menu-toggle]');
  if(toggle){document.body.classList.toggle('menu-open');toggle.setAttribute('aria-expanded',document.body.classList.contains('menu-open'));}
  const close=e.target.closest('[data-menu-close]');
  if(close){document.body.classList.remove('menu-open');}
});
document.addEventListener('change', function(e){
  if(e.target.matches('[data-variant-select]')){
    const option=e.target.options[e.target.selectedIndex];
    const price=e.target.closest('[data-product-root]')?.querySelector('[data-product-price]');
    if(price && option.dataset.price) price.textContent=option.dataset.price;
  }
});
